var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"zones-modal",attrs:{"wide":""},on:{"close":function($event){return _vm.$emit('close', $event)}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h2',[_vm._v(_vm._s(_vm.$t('zoneModalTitle')))])]},proxy:true}])},[_c('ViewZones',{attrs:{"building":_vm.building}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }